import React,{useState} from 'react';
import { Button } from 'react-bootstrap';
import paymentRequest from 'pages/sales/paymentRequest';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';

const PerformanceFilter = ({
  showFilter = true,
  filterToggle,
  applyFilter,
  listFilterData = null,
}) => {
    const [filterData, setFilterData] = useState(listFilterData || null);
    const handleRadioChange = (event) => {
        setFilterData({"days_filter":event.target.value});
      };
  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filters</h4>
          </div>
          <div className="filter-body scrollbar-styling">
            <h4>Select Duration</h4>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="duration"
                id="7-days"
                value="7"
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="7-days">
                7 Days
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="duration"
                id="15-days"
                value="15"
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="15-days">
                15 Days
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="duration"
                id="30-days"
                value="30"
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="30-days">
                30 Days
              </label>
            </div>
          </div>
          {console.log(filterData)}
          <div className="btn-wrapper">
                <button type="submit" className="btn btn-primary" 
                onClick={() => {
                    applyFilter({
                        days_filter: '',
                    });
                }}>
                    {localization.removeFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        applyFilter(filterData);
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.applyFilter}
                </button>
            </div>
        </div>
      )}
    </div>
  );
};

export default PerformanceFilter;
